import React, { useState } from "react";
import { getIcons } from "../../Constant/Constant";

const IntegrationLeadSourceModel = ({ isOpen, close , onIntegration }) => {
  const icons = getIcons();

  const LeadSource = [
    { label: "Facebook ADS", icon: icons.faceBookIcon, available: true },
    { label: "Google ADS", icon: icons.googleIcon, available: false },
    { label: "Zapier ADS", icon: icons.ZapierIcon, available: false },
  ];

  const [selected, setSelected] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  const filteredSources = LeadSource.filter((source) =>
    source.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (source) => {
    if (source.available) {
      setSelected(source.label);
    }
  };

  if (!isOpen) return null;

  const handleFacebookIntegration = (select) => {
   
    onIntegration(select)

  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white  flex flex-col gap-6 rounded-lg p-6 w-full max-w-2xl relative">
        <div className="flex items-center justify-between bg-slate-100  px-3 py-4 rounded-md ">
          <div className="text-lg font-medium text-customGreen">
            Select Your Integration Lead Source
          </div>
          <button
            onClick={close}
            className=" text-2xl bg-white rounded-full w-10 h-10  text-red-500"
            >
            &times;
          </button>
        </div>

        <div className="flex items-center gap-2">
          <div className="relative flex  w-full items-center ">
            <img
              src={icons.searchIcon}
              alt=""
              className="absolute left-4 w-5 h-5"
            />
            <input
              type="text"
              placeholder="Search Integrations"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="setup-search pl-10 pr-4 h-11 rounded-lg py-3 px-4 border-stone-400 shadow appearance-none border  text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            />
          </div>

          <button
            onClick={()=>handleFacebookIntegration(selected)}
            disabled={!selected || selected !== "Facebook ADS"}
            className={` px-10 py-2 rounded text-white font-semibold 
            ${
              selected === "Facebook ADS"
                ? "bg-customGreen"
                : "bg-gray-400 cursor-not-allowed"
            }
          `}
          >
            Continue
          </button>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
          {filteredSources.map((source, index) => (
            <div
              key={index}
              onClick={() => handleSelect(source)}
              className={`relative p-4 border rounded-lg cursor-pointer transition
    ${selected === source.label ? "border-blue-500" : "border-gray-300"}
   
    group
  `}
            >
              <img
              
                src={source.icon}
                alt={source.label}
                className="w-10 h-10 mx-auto mb-2"
              />
              <p className="text-center">{source.label}</p>

              {!source.available && (
                <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-90 text-customGreen text-sm font-semibold transition-opacity duration-300 opacity-0 group-hover:opacity-100 pointer-events-none">
                  Coming Soon
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IntegrationLeadSourceModel;
